module.exports = __webpack_public_path__ + "static/key-xcom2-d041aba84354cced93e12e22f634e9c1.webp";